export default __webpack_public_path__ + "static/laptop-151a7f6325dd1c5facf386d1ee2ec3a3.png";